import { Routes as Switch, Route, Navigate } from 'react-router-dom';
import { Page, Sidebar, SideNav } from '@servicetitan/design-system';
import * as Styles from './marketing-page.module.less';
import { MarketingRoutes } from '../../enums/marketing-routes';
import { asParentPath } from '../../../../../common/utils/as-parent-path';
import { SideNavLink } from '../../../../../common/components/side-nav-link/side-nav-link';
import { PipelinesPage } from '../../../pipelines/components/pipelines-page/pipelines-page';
import { FieldsSettingsPage } from '../../../fields-settings/components/fields-settings-page/fields-settings-page';
import { TransparentMarketingPage } from '../../../transparent-marketing/components/transparent-marketing-page/transparent-marketing-page';

export const MarketingPage = () => {
    return (
        <Page
            className={Styles.topLevelPage}
            sidebar={
                <Sidebar localStorageKey="standalone-ap__marketing-sidebar-key">
                    <SideNav title="Marketing Pro">
                        <SideNavLink to={MarketingRoutes.Pipelines} name="Pipelines" />
                        <SideNavLink to={MarketingRoutes.FieldsSettings} name="Fields Settings" />
                        <SideNavLink
                            to={MarketingRoutes.TransparentMarketing}
                            name="Transparent Marketing"
                        />
                    </SideNav>
                </Sidebar>
            }
        >
            <Switch>
                <Route path={asParentPath(MarketingRoutes.Pipelines)} element={<PipelinesPage />} />
                <Route
                    path={asParentPath(MarketingRoutes.FieldsSettings)}
                    element={<FieldsSettingsPage />}
                />
                <Route
                    path={asParentPath(MarketingRoutes.TransparentMarketing)}
                    element={<TransparentMarketingPage />}
                />
                <Route path="*" element={<Navigate to={MarketingRoutes.Pipelines} replace />} />
            </Switch>
        </Page>
    );
};
